// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__snGiA","body":"Tags_body__Fnx4a"};